import React from "react";
import Benefits from "../components/pagescomponents/benefits/Benefits";
import BuyMula from "../components/pagescomponents/buymula/BuyMula";
import MulaNote from "../components/pagescomponents/mulanote/MulaNote";
import Partners from "../components/pagescomponents/partners/Partners";
import Supply from "../components/pagescomponents/supply/Supply";
import WhatIsMula from "../components/pagescomponents/whatismula/WhatIsMula";
import WhyMula from "../components/pagescomponents/whymula/WhyMula";

const Token = () => {
  return (
    <div>
      <WhatIsMula />
      <WhyMula />
      <Benefits/>
      <Supply/>
      <BuyMula/>
      <MulaNote/>
      <Partners/> 
    </div>
  );
};

export default Token;
